import heroHeaderBg from '@/assets/hero-header-bg.png'
import appSettings from '@/config/appSettings'
import ReactMarkdown from 'react-markdown'

const HeroHeader = () => {
  return (
    <section
      className='relative flex h-[25vh] bg-cover bg-bottom bg-no-repeat md:h-[50vh]'
      style={{ backgroundImage: `url(${heroHeaderBg})` }}
    >
      {/* Overlay for small screens */}
      <div className='absolute inset-0 bg-black/85 md:hidden' />

      {/* Gradient overlay for md and up */}
      <div className='absolute inset-0 hidden bg-gradient-to-r from-black/85 via-black/75 to-black/40 md:block' />

      {/* Content */}
      <div className='relative z-10 h-full w-full px-8 text-white md:px-10 lg:px-20'>
        {/* Logo and Product Name */}
        <div className='absolute top-1/2 flex -translate-y-1/2 flex-row items-center space-x-4 md:space-x-5'>
          <img
            src={appSettings.logo}
            alt='Hubble Logo'
            className='h-15 w-15 md:h-30 md:w-30'
          />
          <h1 className='sky-text pointer-events-none text-3xl font-bold md:text-7xl'>
            {appSettings.name.toLowerCase()}
          </h1>
        </div>
        <div className='pointer-events-none absolute top-[70%] pr-6 text-sm text-white md:top-[75%] md:pr-10 md:text-xl lg:pr-20'>
          <ReactMarkdown
            components={{
              p: ({ children }) => <p>{children}</p>,
              strong: ({ children }) => (
                <strong className='font-semibold'>{children}</strong>
              ),
            }}
          >
            {appSettings.shortDescription}
          </ReactMarkdown>
        </div>
      </div>
    </section>
  )
}

export default HeroHeader
